const REGEX_EMAIL = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

export const isEmailValid = (email: string) => REGEX_EMAIL.test(email);
